/* WYN Living — scroll reveal.
   Progressive enhancement: content is fully visible without JS. Only elements below the fold are
   hidden (just before they scroll into view) and then revealed with a short fade-up.
   Does nothing when the visitor prefers reduced motion. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SINGLES = [
    '.wr-head', '.wr-story__media', '.wr-story__body', '.wr-about__head', '.wr-about__intro',
    '.wr-about__banner', '.wr-cta .wr-wrap > *', '.wr-news .wr-wrap > *', '.wr-article__image',
    '.wr-rte', '.wr-lc__head > *', '.wr-blog__head > *', '.wr-coll__head > *', '.wr-post--large',
    '.wr-pager'
  ];
  var GROUPS = [
    '.wr-grid', '.wr-cats__grid', '.wr-materials__grid', '.wr-why__grid', '.wr-values__grid',
    '.wr-posts', '.wr-lc__grid', '.wr-pw-preview__grid'
  ];

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = parseInt(el.style.getPropertyValue('--wr-d'), 10) || 0;
          el.classList.add('is-in');
          io.unobserve(el);
          // Once the entrance has finished, hand the element back to its normal styles (e.g. hover lift)
          setTimeout(function () {
            el.classList.remove('wr-reveal', 'is-in');
            el.style.removeProperty('--wr-d');
          }, delay + 1100);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function prep(el, delay) {
    if (!el || el.classList.contains('wr-reveal') || el.classList.contains('is-in')) return;
    if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return; // already on screen
    el.style.setProperty('--wr-d', delay + 'ms');
    el.classList.add('wr-reveal');
    io.observe(el);
  }

  function run(root) {
    var scope = root || document;
    SINGLES.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (el) { prep(el, 0); });
    });
    GROUPS.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (grid) {
        Array.prototype.forEach.call(grid.children, function (child, i) { prep(child, (i % 6) * 90); });
      });
    });
  }

  run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

/* WYN Living — silent looping video: plays while on screen, pauses off screen, has a pause button.
   With reduced motion (or no IntersectionObserver) the video does not autoplay and shows controls instead. */
(function () {
  var videos = document.querySelectorAll('.wr-video__el');
  if (!videos.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(videos, function (video) {
    var frame = video.closest('.wr-video__frame');
    var btn = frame && frame.querySelector('[data-wr-video-toggle]');
    video.muted = true;
    video.setAttribute('playsinline', '');

    if (reduce || !('IntersectionObserver' in window)) {
      video.controls = true;
      video.autoplay = false;
      return;
    }

    var userPaused = false;
    function setBtn(paused) {
      if (!btn) return;
      btn.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }
    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        if (video.paused) { userPaused = false; video.play(); } else { userPaused = true; video.pause(); }
      });
    }
    video.addEventListener('play', function () { setBtn(false); });
    video.addEventListener('pause', function () { setBtn(true); });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (!userPaused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.35 }).observe(video);
  });
})();
